import { observer } from 'mobx-react';
import GenericSortFilter from '../../../../../GenericSortFilter';
import { SearchParameter, SearchParameters } from '../../../../../../ListFilter/Types';
import { whenGt } from '@execonline-inc/numbers';
import { just } from 'maybeasy';
import { DeepLinksOptionsResource } from '../DeepLinksOptionsStore/Types';
import { emptyFragment } from '../../../../../../EmptyFragment';

interface Props {
  duplicateProgramDeepLinkCount: number;
  resource: DeepLinksOptionsResource;
  searchParameters: SearchParameters;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
}

function Body({
  duplicateProgramDeepLinkCount,
  resource,
  searchParameters,
  updatingSearchParameters,
}: Props) {
  return (
    <>
      <div className="mr-4 w-1/3">
        <GenericSortFilter
          labelText="Program Type"
          options={resource.payload.programTypes}
          parameters={searchParameters}
          updatingParameters={updatingSearchParameters}
          sortFilterKey={'program_type'}
        />
      </div>
      {just(duplicateProgramDeepLinkCount)
        .andThen(whenGt(0))
        .map(() => (
          <div className="mr-4 w-1/3">
            <GenericSortFilter
              labelText="Delivery Channel"
              options={resource.payload.deliveryChannels}
              parameters={searchParameters}
              updatingParameters={updatingSearchParameters}
              sortFilterKey={'delivery_channel'}
            />
          </div>
        ))
        .getOrElse(emptyFragment)}
    </>
  );
}

export default observer(Body);
